module.exports = __webpack_public_path__ + "img/slide-img-1.99b07772.png";